<template>
  <div class="logo-container" :class="{ 'logo-small': small }">
    <!-- Using inline SVG instead of external image -->
    <div class="logo-modern">
      <div class="logo-icon">
        <svg 
          :width="size" 
          viewBox="0 0 958.000000 330.000000"
          preserveAspectRatio="xMidYMid meet"
          class="logo-svg"
        >
          <g transform="translate(0.000000,330.000000) scale(0.100000,-0.100000)"
          fill="var(--logo-icon-color, #2E8B57)" stroke="none">
            <path d="M811 3182 c-52 -26 -74 -63 -79 -132 l-4 -60 -92 0 c-105 0 -206 -19
            -266 -50 -61 -31 -132 -106 -166 -175 l-29 -60 -3 -989 c-1 -636 1 -1009 8
            -1045 5 -31 28 -93 50 -139 66 -132 176 -230 320 -283 l65 -24 1010 0 1010 0
            62 26 c133 58 232 149 293 270 21 43 43 102 49 131 8 37 11 355 9 1053 l-3
            1000 -27 56 c-56 113 -173 198 -304 219 -33 6 -96 10 -141 10 l-83 0 0 48 c0
            126 -118 202 -218 140 -41 -25 -71 -86 -72 -145 l0 -43 -595 0 -595 0 0 58 c0
            69 -23 112 -73 135 -45 22 -83 21 -126 -1z m1990 -625 c19 -12 44 -42 57 -67
            l22 -45 -2 -885 -3 -885 -27 -57 c-37 -80 -108 -152 -187 -191 l-66 -32 -980
            0 -980 0 -67 32 c-89 42 -151 101 -191 182 l-32 66 -3 885 -3 885 23 45 c13
            25 38 55 57 67 l34 23 1157 0 1157 0 34 -23z m-2474 -319 c-3 -8 -6 -5 -6 6
            -1 11 2 17 5 13 3 -3 4 -12 1 -19z m0 -70 c-2 -13 -4 -5 -4 17 -1 22 1 32 4
            23 2 -10 2 -28 0 -40z m0 -250 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12
            1 -19z m0 -105 c-3 -10 -5 -2 -5 17 0 19 2 27 5 18 2 -10 2 -26 0 -35z m0
            -150 c-3 -10 -5 -4 -5 12 0 17 2 24 5 18 2 -7 2 -21 0 -30z m0 -280 c-2 -16
            -4 -5 -4 22 0 28 2 40 4 28 2 -13 2 -35 0 -50z m0 -130 c-3 -10 -5 -4 -5 12 0
            17 2 24 5 18 2 -7 2 -21 0 -30z m0 -65 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2
            -7 2 -19 0 -25z m0 -240 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z"/>
            <path d="M1498 2297 c-161 -74 -171 -309 -18 -387 200 -100 398 116 281 307
            -35 56 -94 87 -170 90 -37 1 -78 -3 -93 -10z"/>
            <path d="M2444 2236 c-17 -8 -159 -83 -315 -167 -280 -151 -392 -205 -519
            -249 -78 -27 -274 -125 -356 -178 -77 -50 -176 -141 -167 -155 3 -6 1 -7 -5
            -3 -14 9 -204 -163 -195 -177 3 -6 1 -7 -5 -3 -15 9 -77 -47 -92 -84 -10 -24
            -10 -33 0 -45 28 -34 68 -18 283 119 117 73 253 158 302 189 l90 56 5 -38 c3
            -21 18 -61 32 -90 l26 -52 -37 -48 c-76 -101 -197 -239 -228 -261 -18 -12 -63
            -33 -100 -46 -104 -37 -163 -66 -156 -77 3 -6 1 -7 -4 -4 -6 4 -66 -20 -134
            -52 -68 -32 -134 -61 -146 -65 -12 -4 -36 -20 -52 -36 -25 -22 -31 -36 -31
            -68 0 -47 19 -66 57 -60 68 12 575 172 639 202 39 19 125 69 190 113 186 125
            201 130 291 94 27 -10 111 -33 188 -50 76 -17 147 -39 156 -47 10 -9 39 -73
            64 -142 26 -70 56 -147 68 -172 34 -70 101 -89 128 -38 16 30 13 81 -16 263
            -45 288 -37 278 -290 369 -71 26 -140 57 -153 70 -18 18 -30 55 -54 174 -28
            138 -30 155 -17 182 8 17 76 76 167 145 89 68 150 121 146 127 -4 7 -2 8 4 4
            7 -4 73 40 158 105 177 137 194 157 158 193 -19 19 -39 20 -80 2z m-957 -728
            c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z"/>
            <path d="M5193 2726 c-125 -31 -226 -106 -272 -206 -35 -78 -37 -211 -2 -287
            50 -112 173 -193 386 -254 131 -37 154 -48 189 -89 53 -63 24 -164 -59 -205
            -55 -27 -162 -31 -245 -10 -36 9 -102 36 -148 60 l-82 44 -50 -100 -50 -99 62
            -40 c177 -113 454 -132 637 -45 132 64 201 164 209 306 6 97 -10 165 -53 224
            -64 91 -148 137 -360 200 -171 51 -222 95 -212 182 9 83 64 117 187 117 94 0
            157 -17 253 -67 31 -16 59 -28 61 -26 2 2 24 45 50 96 l46 92 -33 25 c-42 32
            -117 64 -192 82 -73 17 -251 17 -322 0z"/>
            <path d="M3997 2623 c-135 -369 -411 -1131 -414 -1145 -5 -16 5 -18 119 -18
            l124 0 46 123 45 122 260 3 260 2 45 -126 44 -126 124 1 c69 1 126 4 128 6 2
            1 -71 207 -161 456 -91 250 -193 532 -227 627 l-63 172 -147 0 -148 0 -35 -97z
            m256 80 c-7 -2 -19 -2 -25 0 -7 3 -2 5 12 5 14 0 19 -2 13 -5z m11 -533 c47
            -134 86 -245 86 -247 0 -2 -79 -3 -175 -3 -96 0 -175 2 -175 5 0 11 173 495
            176 492 2 -1 41 -112 88 -247z"/>
            <path d="M8970 2523 l0 -123 -70 0 -70 0 0 -105 0 -105 75 0 75 0 0 -258 c0
            -287 6 -329 60 -394 17 -20 56 -49 88 -65 51 -25 67 -28 162 -28 62 0 120 5
            143 13 l37 14 0 99 0 99 -26 -10 c-40 -16 -123 -12 -155 7 -51 31 -59 70 -59
            308 l0 215 120 0 120 0 0 105 0 105 -120 0 -120 0 0 123 0 122 -130 0 -130 0
            0 -122z"/>
            <path d="M8622 2405 c-75 -17 -120 -42 -167 -98 l-35 -41 0 67 0 67 -125 0
            -125 0 0 -469 0 -470 125 -3 125 -3 0 266 c0 302 7 345 65 404 41 41 114 65
            197 65 l58 0 0 115 0 115 -27 -1 c-16 0 -56 -7 -91 -14z"/>
            <path d="M6333 2396 c-55 -18 -107 -50 -138 -87 l-25 -31 0 61 0 61 -120 0
            -120 0 0 -645 0 -645 120 0 120 0 0 236 0 236 27 -32 c64 -77 166 -114 292
            -108 240 14 399 178 418 433 16 222 -80 411 -252 496 -64 31 -77 34 -175 36
            -68 2 -120 -2 -147 -11z m219 -231 c126 -87 145 -325 35 -439 -125 -131 -359
            -74 -407 99 -18 65 -9 200 17 250 48 92 112 126 230 123 72 -3 86 -6 125 -33z"/>
            <path d="M7346 2385 c-180 -63 -291 -198 -318 -385 -37 -250 125 -486 373
            -545 289 -68 562 92 618 363 54 262 -95 512 -344 577 -94 24 -245 20 -329 -10z
            m289 -204 c46 -20 101 -79 122 -129 8 -18 17 -62 20 -96 18 -198 -141 -344
            -319 -292 -112 33 -169 110 -176 242 -7 133 37 227 130 273 56 27 165 29 223
            2z"/>
            <path class="logo-text" d="M5078 914 c-28 -15 -37 -34 -41 -91 -2 -29 -6 -33 -29 -33 -23 0 -28
            -4 -28 -25 0 -20 5 -25 25 -25 l25 0 0 -135 0 -135 30 0 30 0 0 135 0 135 48
            0 c44 0 47 2 47 25 0 23 -3 25 -51 25 l-51 0 5 33 c5 38 26 57 64 57 21 0 28
            5 28 19 0 33 -55 41 -102 15z"/>
            <path class="logo-text" d="M3566 908 c5 -7 41 -64 81 -127 l73 -114 0 -99 c0 -98 0 -98 25 -98
            25 0 25 0 25 99 l0 99 80 126 80 126 -33 0 c-30 0 -36 -7 -90 -95 -32 -52 -62
            -93 -67 -90 -5 3 -32 46 -62 95 -50 84 -55 90 -86 90 -24 0 -31 -3 -26 -12z"/>
            <path class="logo-text" d="M5234 905 c-10 -25 4 -45 30 -45 27 0 42 26 25 46 -15 19 -48 18 -55
            -1z"/>
            <path class="logo-text" d="M7680 695 l0 -225 25 0 25 0 0 225 0 225 -25 0 -25 0 0 -225z"/>
            <path class="logo-text" d="M8740 835 l0 -84 -37 25 c-69 47 -158 19 -194 -59 -50 -111 2 -239
            102 -248 52 -5 77 2 103 27 l26 27 0 -27 c0 -21 5 -26 25 -26 l25 0 0 225 0
            225 -25 0 c-25 0 -25 -1 -25 -85z m-32 -119 c37 -36 41 -110 10 -156 -32 -47
            -76 -59 -120 -33 -66 38 -75 138 -17 196 26 25 35 29 66 24 21 -4 48 -17 61
            -31z"/>
            <path class="logo-text" d="M5400 835 c0 -41 -2 -45 -25 -45 -20 0 -25 -5 -25 -25 0 -20 5 -25
            24 -25 24 0 24 -1 28 -114 3 -125 13 -149 66 -159 48 -9 82 3 82 29 0 20 -4
            23 -36 22 -54 -2 -64 18 -64 129 l0 93 45 0 c41 0 45 2 45 25 0 23 -4 25 -45
            25 l-45 0 0 45 c0 41 -2 45 -25 45 -23 0 -25 -4 -25 -45z"/>
            <path class="logo-text" d="M3991 778 c-55 -28 -82 -77 -83 -146 0 -101 58 -164 152 -164 97 0
            154 60 153 162 -1 96 -48 155 -135 166 -33 4 -53 0 -87 -18z m135 -62 c30 -30
            34 -40 34 -85 0 -42 -5 -56 -29 -83 -39 -44 -98 -46 -138 -5 -24 24 -28 35
            -28 88 0 56 3 63 33 90 45 40 84 39 128 -5z"/>
            <path class="logo-text" d="M5710 789 c-13 -6 -33 -17 -42 -26 -17 -15 -18 -15 -18 5 0 15 -6 22
            -20 22 -19 0 -20 -7 -20 -160 l0 -160 25 0 c25 0 25 0 25 94 0 52 4 106 9 119
            24 61 87 85 131 49 20 -17 22 -28 25 -138 l3 -119 26 -3 26 -3 0 118 c0 131
            -14 177 -60 200 -30 15 -75 16 -110 2z"/>
            <path class="logo-text" d="M6035 787 c-54 -25 -95 -94 -95 -160 0 -47 39 -118 77 -140 63 -36
            161 -18 197 37 15 24 15 26 -5 37 -17 9 -23 7 -35 -9 -19 -28 -75 -45 -106
            -33 -31 12 -68 57 -68 82 0 17 9 19 115 19 l115 0 0 30 c0 41 -22 90 -53 119
            -31 29 -99 37 -142 18z m109 -59 c13 -13 27 -33 31 -45 6 -23 5 -23 -84 -23
            -50 0 -91 2 -91 5 0 15 32 65 47 74 30 17 71 12 97 -11z"/>
            <path class="logo-text" d="M6360 793 c-36 -13 -60 -47 -60 -85 0 -48 22 -70 91 -93 64 -21 79
            -31 79 -55 0 -27 -28 -45 -72 -45 -32 0 -45 6 -62 28 -15 19 -28 26 -39 21
            -41 -16 5 -76 72 -94 51 -14 114 1 136 33 22 31 19 93 -4 116 -11 11 -43 27
            -72 35 -60 18 -79 32 -79 57 0 40 71 52 113 19 14 -11 32 -17 41 -14 19 7 19
            9 5 36 -19 35 -102 58 -149 41z"/>
            <path class="logo-text" d="M6643 785 c-36 -15 -53 -42 -53 -83 0 -37 33 -67 96 -88 27 -9 55
            -21 62 -27 32 -25 -6 -77 -56 -77 -13 0 -37 13 -53 29 -29 29 -69 33 -69 6 0
            -23 48 -64 86 -74 42 -11 104 -2 129 19 22 19 37 74 26 101 -12 34 -28 44 -90
            63 -62 18 -81 31 -81 57 0 40 71 52 113 19 28 -22 43 -25 52 -10 11 17 -16 51
            -50 66 -42 17 -71 17 -112 -1z"/>
            <path class="logo-text" d="M7105 786 c-104 -46 -129 -193 -47 -279 53 -56 154 -54 205 3 15 17
            26 37 24 43 -7 22 -37 19 -59 -7 -76 -83 -194 9 -159 123 23 80 98 105 152 52
            19 -20 35 -27 49 -24 25 7 25 14 -2 48 -39 50 -105 66 -163 41z"/>
            <path class="logo-text" d="M7415 787 c-16 -8 -39 -24 -50 -37 -19 -21 -19 -22 -1 -36 17 -12 22
            -10 48 11 17 14 42 25 59 25 34 0 79 -39 79 -67 0 -16 -9 -19 -68 -19 -78 -1
            -106 -13 -127 -54 -20 -40 -19 -72 5 -103 41 -52 121 -56 172 -10 17 15 18 15
            18 -5 0 -17 6 -22 26 -22 l26 0 -4 130 -3 130 -31 31 c-37 37 -101 48 -149 26z
            m119 -173 c44 -17 -17 -104 -73 -104 -33 0 -71 30 -71 55 0 30 38 55 84 55 24
            0 51 -3 60 -6z"/>
            <path class="logo-text" d="M7910 794 c-73 -26 -110 -83 -110 -166 0 -96 60 -160 151 -160 55 1
            89 18 116 59 13 19 12 23 -7 33 -18 10 -24 8 -41 -14 -39 -50 -113 -42 -149
            16 -34 56 -31 58 95 58 l115 0 0 35 c0 49 -23 100 -54 120 -27 18 -91 28 -116
            19z m95 -69 c14 -13 25 -33 25 -45 0 -19 -6 -20 -85 -20 -77 0 -85 2 -85 19 0
            28 56 71 91 71 18 0 39 -10 54 -25z"/>
            <path class="logo-text" d="M8238 776 c-36 -24 -38 -24 -38 -6 0 15 -7 20 -25 20 l-25 0 0 -160
            0 -160 25 0 c25 0 25 1 25 90 0 100 14 148 51 174 33 23 66 20 94 -9 24 -23
            25 -30 25 -140 l0 -115 26 0 26 0 -4 135 c-3 130 -4 135 -29 161 -40 39 -103
            43 -151 10z"/>
            <path class="logo-text" d="M8935 786 c-16 -7 -39 -23 -50 -36 -19 -21 -19 -22 -1 -36 17 -12 22
            -10 48 11 52 44 119 24 134 -39 l7 -29 -44 7 c-134 19 -218 -79 -141 -165 24
            -27 36 -32 74 -33 34 -1 55 5 77 22 30 22 31 22 31 2 0 -15 7 -20 25 -20 l25
            0 0 119 c0 106 -2 121 -23 152 -38 57 -98 73 -162 45z m124 -175 c15 -10 7
            -46 -17 -73 -23 -27 -77 -33 -107 -14 -55 36 -15 96 63 96 26 0 53 -4 61 -9z"/>
            <path class="logo-text" d="M4280 671 c0 -66 4 -131 10 -145 22 -59 114 -79 170 -37 36 26 40 26
            40 1 0 -15 7 -20 25 -20 l26 0 -2 160 -1 160 -29 0 -29 0 0 -109 c0 -100 -2
            -112 -22 -135 -13 -15 -37 -29 -55 -32 -25 -5 -37 -1 -57 19 -25 25 -26 31
            -26 142 l0 115 -25 0 -25 0 0 -119z"/>
            <path class="logo-text" d="M4630 630 l0 -160 24 0 c23 0 24 2 28 111 3 107 4 112 31 135 16 14
            41 24 58 24 24 0 29 4 29 25 0 22 -4 25 -34 25 -19 0 -45 -9 -60 -21 l-26 -20
            0 20 c0 16 -6 21 -25 21 l-25 0 0 -160z"/>
            <path class="logo-text" d="M5234 630 l1 -160 28 0 27 0 0 160 0 160 -28 0 -29 0 1 -160z"/>
            <path class="logo-text" d="M9200 630 l0 -160 24 0 c24 0 24 1 28 111 3 107 4 112 31 135 16 14
            41 24 58 24 24 0 29 4 29 25 0 22 -4 25 -35 25 -25 0 -44 -8 -60 -25 l-25 -24
            0 24 c0 20 -5 25 -25 25 l-25 0 0 -160z"/>
          </g>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLogo',
  props: {
    small: {
      type: Boolean,
      default: false
    },
    showTagline: {
      type: Boolean,
      default: false
    },
    size: {
      type: Number,
      default: 160
    }
  }
}
</script>

<style scoped>
.logo-container {
  display: flex;
  align-items: center;
  font-family: 'Oswald', sans-serif;
}

.logo-modern {
  display: flex;
  align-items: center;
  gap: 14px;
}

.logo-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.logo-svg {
  transition: all 0.3s ease;
  /* No need for CSS filters anymore since we use CSS variables in SVG */
}

/* Logo text and icon styles */
.logo-svg .logo-text {
  fill: var(--logo-text-color, #fff);
}

.logo-svg .logo-icon {
  fill: var(--logo-icon-color, #2E8B57);
}

/* For white backgrounds, use dark text */
.logo-container.white-bg {
  --logo-text-color: #2E8B57; /* Green text on white background */
  --logo-icon-color: #2E8B57; /* Green icon on white background */
}

/* For dark backgrounds, use white text */
.logo-container.dark-bg {
  --logo-text-color: #ffffff; /* White text on dark background */
  --logo-icon-color: #ffffff; /* White icon on dark background */
}

.logo-text-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.logo-brand {
  display: flex;
  align-items: baseline;
  line-height: 1;
}

.logo-brand-as {
  font-size: 2rem;
  font-weight: 700;
  color: var(--color-pallet-1);
  letter-spacing: 0.5px;
}

.logo-brand-port {
  font-size: 1.8rem;
  font-weight: 500;
  color: var(--color-pallet-2);
  margin-left: 1px;
}

/* Small version */
.logo-small .logo-modern {
  gap: 10px;
}

.logo-small .logo-svg {
  width: 140px;
  height: 140px;
}

.logo-small .logo-brand-as {
  font-size: 1.6rem;
}

.logo-small .logo-brand-port {
  font-size: 1.4rem;
}

/* Responsive */
@media (max-width: 768px) {
  .logo-modern {
    gap: 12px;
  }
  
  .logo-brand-as {
    font-size: 1.6rem;
  }
  
  .logo-brand-port {
    font-size: 1.4rem;
  }
}

@media (max-width: 480px) {
  .logo-brand-as {
    font-size: 1.4rem;
  }
  
  .logo-brand-port {
    font-size: 1.2rem;
  }
}
</style> 